import axios from 'axios'

export const state = {
  userFiles: null,
}

export const getters = {
  userFiles: (state) => state.userFiles,
}

export const mutations = {
  SET_USER_FILES(state, userFiles) {
    state.userFiles = userFiles
  },
}

export const actions = {
  fetchAllUserFiles({ commit }, userId) {
    return axios.get(`/api/users/${userId}/files`).then((response) => {
      const userFiles = response.data
      commit('SET_USER_FILES', userFiles)
      return userFiles
    })
  },

  createUserFile(_, payload) {
    const formData = new FormData()
    formData.append('file', payload.file)

    return axios.post(`/api/users/${payload.userId}/files`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },

  deleteUserFile(_, payload) {
    return axios.delete(`/api/users/${payload.userId}/files/${payload.id}`)
  },
}
